import axiosInstance from 'api/axiosInstance';
import { URL_SEARCH_ADDRESSES } from 'constants/urls';

/**
 * Search addresses (locations) with optional customer filter
 * Note: This API expects a JSON payload parameter using custom paramsSerializer
 *
 * @param {number|null} customerId - Filter by customer (optional)
 * @param {string} searchKeyword - Search term
 * @param {number} page - Page number (default: 1)
 * @param {number} take - Items per page (default: 100)
 * @returns {Promise<{data: Array, totalCount: number}>}
 */
const searchAddresses = async (customerId = null, searchKeyword = '', page = 1, take = 100) => {
  const payload = {
    SearchKeyword: searchKeyword,
    Page: page,
    Take: take,
  };

  if (customerId) {
    payload.CustomerId = customerId;
  }

  const { data } = await axiosInstance({
    method: 'GET',
    url: URL_SEARCH_ADDRESSES,
    params: payload,
    paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    data: null,
  });

  return {
    data: data.Data || [],
    totalCount: data.TotalResults || 0,
  };
};

export default searchAddresses;
